import { type Receipt } from '../types';
import {
  useIncomingPayment,
  getReceipts,
  getStatus,
} from '@tectonics/prs/incoming-payment';
import {
  getMainReceipt,
  resolvePaymentTypeCode,
} from '../getters';
import { getReceiptSource } from '../getters/fx-latency';
import { useUserInputValue } from '@tectonics/prs/user-input-values';
import { detectCardBrand } from '@tectonics/prs/card-brand';
import { strategies } from './strategies';

export function useCurrentReceipt(): Receipt {
  const incomingPayment = useIncomingPayment();
  const paymentStatus = getStatus(incomingPayment);

  const [selectedPaymentMethodCode] = useUserInputValue<string>('selectedPaymentMethod');
  const [selectedInstalment] = useUserInputValue<string>('selectedInstalment');
  const [cardNumber] = useUserInputValue<string | undefined>('cardNumber');

  const resolveReceipts = () => {
    const paymentTypeCode = resolvePaymentTypeCode(selectedPaymentMethodCode, detectCardBrand(cardNumber ?? ''));

    return getReceiptSource(getReceipts(incomingPayment), paymentTypeCode);
  };

  const matchedStrategy = strategies.find(({ matches }) => matches({ paymentStatus, selectedPaymentMethodCode }));
  const receipt = matchedStrategy?.getReceipt({ resolveReceipts, selectedInstalment, incomingPayment, selectedPaymentMethodCode });

  return receipt ?? getMainReceipt(resolveReceipts());
}
